import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=04787b42"
import script from "./input-date.vue?vue&type=script&lang=js"
export * from "./input-date.vue?vue&type=script&lang=js"
import style0 from "./input-date.vue?vue&type=style&index=0&id=04787b42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports